import { render, staticRenderFns } from "./EditShipmentPerOrder.vue?vue&type=template&id=0c5a584b"
import script from "./EditShipmentPerOrder.vue?vue&type=script&lang=js"
export * from "./EditShipmentPerOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports